import { useState } from 'react';

export function useStorage<V>(
  _storageArea: 'session' | 'local',
  _key: string,
  defaultValue: V = null
): [V | null, (v: V) => void] {
  return useState<V | null>(defaultValue);
}
